import React, { useEffect, useState, useRef } from 'react';
import '../index.css';
import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { makeStyles } from '@material-ui/core/styles';

import { Select, MenuItem, TextField, RadioGroup, FormControl, FormControlLabel, Radio, Input } from '@material-ui/core';
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";
import http from "../services/httpService";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import toast from 'react-hot-toast';
import handleSubmitValidation from '../utils/handleSubmitValidation';
import handleValidation from '../utils/handleValidations';
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        paddingTop: theme.spacing(2),
        textAlign: 'left',
        color: theme.palette.text.primary,
    },
    submitButton: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(10),


    },
    gridDevider: {
        marginTop: theme.spacing(6),
        textAlign: 'left',
        color: theme.palette.text.primary,
    },
    lableColor: {
        color: "#393939"
    },
    select: {
        height: 36,
        minWidth: 235,

    },
    mobileCode: {
        height: 36,
    },
    radio: {
        '&$checked': {
            color: '#57bf74'
        }
    },

    checked: {}

}));
function AddLookup() {
    let history = useHistory();
    let [lookupFile, setLookupFile] = useState(null);
    const classes = useStyles();
    const location = useLocation()
    const myparams = location.state;
    const [updateForm, setUpdateFrom] = useState(false);
    const fileInputRef = useRef(null)

    let form = {
        'lookupid': "",
        'lookupmasterid': "",
        'lookupname': "",
        'lookuppagename': "",
        'lookupparam1': "",
        'lookupparam2': "",
        'lookupfile': null,
        'lookupstatus': "A"
    }
    const [formObject, setFromObject] = useState(false);
    const validations = {
        "lookupid": {
            conditions: {
                "required": true, "pattren": /^[0-9\b]+$/
            }, "message": "This Field is required!", "valid": true, "changed": false
        },
        "lookupmasterid": {
            conditions: {
                "required": true, "pattren": /^[0-9\b]+$/
            }, "message": "Maximum 20 character Allowed.!", "valid": true, "changed": false
        },
        "lookupname": {
            conditions: {
                "required": true
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },
        "lookuppagename": {
            conditions: {
                "required": true,
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        }

    }
    const [validationState, setValidationState] = useState(validations)
    const columns = [
        { "value": 'lookupid', label: 'Lookup ID', minWidth: 170, "filedType": "text", imp: true },
        { "value": 'lookupmasterid', label: 'Lookup Master ID', minWidth: 150, "filedType": "text", imp: true },
        { "value": 'lookupname', label: 'Lookup Name', minWidth: 150, "filedType": "text", imp: true },
        { "value": 'lookuppagename', label: 'Lookup Page Name', minWidth: 150, "filedType": "text", imp: true },
        { "value": 'lookupparam1', label: 'Lookup Parameter 1', minWidth: 150, "filedType": "text" },
        { "value": 'lookupparam2', label: 'Lookup Parameter 2', minWidth: 150, "filedType": "text" },
        { "value": 'lookupfile', label: 'Lookup File', minWidth: 150, "filedType": "file" },
        { "value": 'lookupstatus', label: 'Status', minWidth: 150, "filedType": "radio", "options": [{ "label": "Active", "value": "A" }, { "label": "Inactive", "value": "I" }] },
    ];
    const handleCancel = () => {
        if (myparams && myparams.id) {
            setUpdateFrom(true);
            let updateForm = {
                'lookupid': myparams.lookupid,
                'lookupmasterid': myparams.lookupmasterid,
                'lookupname': myparams.lookupname,
                'lookuppagename': myparams.lookuppagename,
                'lookupparam1': (myparams.lookupparam1) ? myparams.lookupparam1 : "",
                'lookupparam2': (myparams.lookupparam2) ? myparams.lookupparam2 : "",
                'lookupfile': null,
                'lookupstatus': myparams.lookupstatus
            }
            setFromObject(updateForm)
        } else {
            setFromObject(form)

        }
    }
    useEffect(() => {
        localStorage.removeItem("prospectFilter");
        localStorage.removeItem("investmentFilter");
        localStorage.removeItem("ticketFilter");
        localStorage.removeItem("internalFilter")
        localStorage.removeItem("selectedfiltersdata")
        localStorage.removeItem('selectedinvestorfiltersdata')
        handleCancel()

    }, [])
    const handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        let valid = true;
        let validStateTemp = { ...validationState }
        if (name && validStateTemp.hasOwnProperty(name)) {
            let validation = handleValidation(name, value, validStateTemp);

            setValidationState(validation.validStateTemp)
            valid = validation.valid
        }
        if (valid || value === "" || value === 0) {
            setFromObject({
                ...formObject,
                [event.target.name]: event.target.value
            });
        }
    }
    const handleFileChange = (event) => {
        setLookupFile(event.target.files[0])
    }
    const handleUpdate = (event) => {
        event.preventDefault();
        let validStateTemp = { ...validationState }
        let validCount = 0;
        let finalObjet = { ...formObject };

        let validData = handleSubmitValidation(finalObjet, validStateTemp)
        validCount = validData.validCount;
        if (validCount === 0) {
            const formData = new FormData();
            formData.append("lookupid", formObject["lookupid"]);
            formData.append("lookupmasterid", formObject["lookupmasterid"]);
            formData.append("lookupname", formObject["lookupname"]);
            formData.append("lookuppagename", formObject["lookuppagename"]);
            formData.append("lookupparam1", formObject["lookupparam1"]);
            formData.append("lookupparam2", formObject["lookupparam2"]);
            formData.append("lookupstatus", formObject["lookupstatus"]);
            if (lookupFile) {
                formData.append("lookupfile", lookupFile, lookupFile["name"]);

            } else {
                // formData.append("lookupfile",null);
            }
            http.put("/updatelookupmaster/" + myparams.id + "/", formData,
            ).then((response) => {
                if (response && response.data && response.data.id) {
                    toast.success("Lookup Updated Successfully")
                    history.goBack();
                } else {
                    toast.error("Lookup Updated failed..!")
                }
            }).catch((error) => {
                toast.error("Lookup Updated failed..!")
            })
        } else {
            setValidationState(validData.validStateTemp);
            toast.error("Please check Errors in Field level!")
        }
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        let validStateTemp = { ...validationState }
        let validCount = 0;
        let finalObjet = { ...formObject };

        let validData = handleSubmitValidation(finalObjet, validStateTemp)
        validCount = validData.validCount;
        if (validCount === 0) {
            const formData = new FormData();
            formData.append("lookupid", formObject["lookupid"]);
            formData.append("lookupmasterid", formObject["lookupmasterid"]);
            formData.append("lookupname", formObject["lookupname"]);
            formData.append("lookuppagename", formObject["lookuppagename"]);
            formData.append("lookupparam1", formObject["lookupparam1"]);
            formData.append("lookupparam2", formObject["lookupparam2"]);
            formData.append("lookupstatus", formObject["lookupstatus"]);
            if (lookupFile) {
                formData.append("lookupfile", lookupFile, lookupFile["name"]);

            } else {
                // formData.append("lookupfile",null);
            }
            http.post("/lookupmaster", formData,
            ).then((response) => {
                if (response && response.data && response.data.id) {
                    toast.success("Lookup Inserted Successfully")
                    history.goBack();
                } else {
                    toast.error("Lookup Insertion failed..!")
                }
                // setFromObject(form)
            }).catch((error) => {
                toast.error("Lookup Insertion failed..!")
            })
        } else {
            setValidationState(validData.validStateTemp);
            toast.error("Please check Errors in Field level!")
        }
    }
    return (

        <Grid container component="main" className="pb30">

            <Grid item xs={12} sm={5} md={5} >
                <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={history.goBack} style={{ marginTop: 20, marginBottom: 25 }}>Back</Button>
            </Grid>
            <Grid item xs={12} sm={5} md={5} >
                <Typography color="textPrimary" variant="h5" style={{ marginTop: 20, marginBottom: 25 }}>{updateForm ? "View/Edit Look Up details" : "Add New Lookup Details"}</Typography>
            </Grid>
            {
                columns.map(question => {
                    return (
                        <Grid container className={classes.paper}>
                            <Grid item xs={12} sm={2} md={2} className={"formLable"}>
                                <InputLabel className={classes.lableColor} id={question.lable}>{question.label}
                                    {question.imp && (
                                        <span
                                            style={{
                                                color: "red",
                                                fontSize: "1.2rem",
                                                marginLeft: "0.2rem",
                                            }}
                                        >
                                            *
                                        </span>
                                    )}

                                </InputLabel>
                            </Grid>
                            <Grid item xs={12} lg={3} md={3} sm={3}>{question.filedType === "text" ?
                                <TextField label="Enter" variant="outlined" value={formObject[question.value]} name={question.value} onChange={handleChange}
                                    style={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? { paddingBottom: 20 } : {}}
                                    error={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid']}
                                    helperText={validationState.hasOwnProperty(question.value) && validationState[question.value]['changed'] && !validationState[question.value]['valid'] ? validationState[question.value]['message'] : ""}
                                /> : question.filedType === "radio" ?
                                    <RadioGroup row aria-label="position" name={question.value} defaultValue="A" value={formObject[question.value] ? formObject[question.value] : "A"} onChange={handleChange}>
                                        {
                                            question.options.map(option => {
                                                return (
                                                    <FormControlLabel
                                                        control={<Radio classes={{ root: classes.radio, checked: classes.checked }} value={option.value} />}
                                                        label={option.label}
                                                        labelPlacement="end"
                                                    />
                                                )
                                            })

                                        }


                                    </RadioGroup> : question.filedType === "file" ? <>
                                        <input
                                            ref={fileInputRef}
                                            onChange={handleFileChange}
                                            type="file"
                                            style={{ display: "none" }}
                                            multiple={false}
                                            accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
                                        />
                                        <Button startIcon={<AddCircleOutlineIcon />} variant="outlined" className={classes.reviewButton} color="primary" onClick={() => fileInputRef.current.click()}>Choose File</Button>
                                        <span className="fileLable">{lookupFile && lookupFile.name ? lookupFile.name : "No file chosen"}</span></>
                                        : ""}
                            </Grid>
                        </Grid>
                    )
                })
            }
            <Grid container className={classes.submitButton}>
                <Grid item xs={false} sm={2} md={2} >

                </Grid>
                <Grid item xs={12} sm={1} md={1} >
                    <Button variant="outlined" color="primary" onClick={handleCancel} className="addBtn">cancel</Button>
                </Grid>

                <Grid item xs={12} sm={2} md={2} >
                    <Button variant="contained" color="primary" onClick={updateForm ? handleUpdate : handleSubmit} className="addBtn">{updateForm ? "Update Lookup" : "Add Lookup"}</Button>
                </Grid>
            </Grid>
        </Grid>
    )

}


export default AddLookup;